<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-kid-from-port-douglas">
<h1>The Kid from Port Douglas</h1>
<p style="text-align: center;">Night Train to Lisbon, she read on the board,</p>
<p style="text-align: center;">In a small town with the sea, that was all.</p>
<p style="text-align: center;">The board that she read was so full of delights,</p>
<p style="text-align: center;">And promised a journey ahead.</p>
<br/>
<p style="text-align: center;">The promise was only a night at the flicks,</p>
<p style="text-align: center;">Where one could learn how the rich got their kicks.</p>
<p style="text-align: center;">At that billboard she glared on her way to the beach,</p>
<p style="text-align: center;">In a town of mosquitos and mangoes and stench.</p><br/>
<p style="text-align: center;">She fell asleep with that board on her mind,</p>
<p style="text-align: center;">Saw pictures that spoke of a glamorous life,</p>
<p style="text-align: center;">Courage and romance and beautiful things,</p>
<p style="text-align: center;">The rancour of childhood disabled her wings.</p><br/>
<p style="text-align: center;">To Lisbon one day, she’d go on that rain,</p>
<p style="text-align: center;">Live the big dream, explore the unknown.</p>
<p style="text-align: center;">The kid from Port Douglas could vanish for good,</p>
<p style="text-align: center;">The big world was waiting, embrace it she would.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0bcee4f2